import { AnswerPath, LocalizedQuestionnaire, QuestionnaireBlueprint } from '@zinnia/form-engine-sdk';

import ApiService from './ApiService';
import { QuestionnaireVersionFlag } from '@breathelife/types';

export type CarrierQuestionnaireResponse = {
  version: string;
  versionId: string | null;
  questionnaire: LocalizedQuestionnaire;
  blueprint?: QuestionnaireBlueprint;
  nodeIdToAnswerPath?: [string, AnswerPath][];
  flags: QuestionnaireVersionFlag[];
};

export async function fetchCarrierQuestionnaire(applicationId: string): Promise<CarrierQuestionnaireResponse> {
  const response = await ApiService.getCarrierQuestionnaire(applicationId);
  return response.data;
}
